import { render, staticRenderFns } from "./TipoRegraCards.vue?vue&type=template&id=e8110ae6&scoped=true"
import script from "./TipoRegraCards.vue?vue&type=script&lang=js"
export * from "./TipoRegraCards.vue?vue&type=script&lang=js"
import style0 from "./TipoRegraCards.vue?vue&type=style&index=0&id=e8110ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8110ae6",
  null
  
)

export default component.exports